import React, { useState, useEffect } from "react";
import BackArrows from "../../Form/BackArrow/BackArrows";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { getIcons } from "../../Constant/Constant";
import MemberList from "./MemberList";
import { useNavigate } from "react-router-dom";
import LeadList from "./LeadList";
import CPManageService from "../../Services/CPManageService";
import { ToastContainer } from "react-toastify";
import { showInfoToast } from "../../Constant/Notification";

const icons = getIcons();
const userObj = JSON.parse(localStorage.getItem("userData"));
const userRole = userObj?.user?.role;

const ChannelPartnerPageWithMembers = () => {
  const [members, setMembers] = useState([]);
  const [leads, setLeads] = useState([]);
  const [totalLead, setTotalLead] = useState(0);
  const [totalMember, setTotalMember] = useState(23);
  const [loading, setLoading] = useState(false);
  const [newPermissionCount, setNewPermissionCount] = useState(null)
  const [dashboardCount, setDashboardCount]= useState(0)

  const navigate = useNavigate();



  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
     
      setLoading(false);
    }, 800);
  }, []);

  useEffect(()=>{
const getMemberList = async () =>{
  try{
    const response = await CPManageService.getMemberList()
    
    console.log("Member", response)
    setMembers(response.data);
    }catch(error){
      console.error(error);
    
    }
}
getMemberList()
  },[])


  const getLeadList = async (id = null, direction = null) => {
    try {
      console.log("Fetching Leads - Direction:", direction, "ID:", id);
  
      let params = {};
      if (direction === "next") {
        params.next = id;
        params.direction = "next";
      } else if (direction === "previous") {
        params.previous = id;
        params.direction = "previous";
      }
  
      const response = await CPManageService.getLeadList(params);
  
      console.log("Fetched Leads:", response.data);
      
      setLeads(response.data); 
      setTotalLead(response.data?.maxLeadCount || 0); 
    } catch (error) {
      if (error.response?.status === 404) {
        console.warn("No leads found, returning empty list.");
        setLeads([]);
      } else {
        console.error("Error fetching leads:", error.response?.data || error.message);
      }
    }
  };

  const handleSearchLead = async (search) => {
    console.log("Searching leads for:", search);
 if(search===null){
  getLeadList();
 }
 else{
  try{
    const body = {
      searchKey: search,
      type : null,
      uid:null
    }
    const response = await CPManageService.CPLeadSearch(body)
    console.log("Search leads response:", response.data);
    setLeads(response.data);
    setTotalLead(response.data?.leads.length);
    
    }catch(error){
      console.error(error)

   }
 }
  };
  
  

  useEffect(() => {
    getLeadList();
  }, []);
  



  useEffect(()=>{
    const getPermissionCount = async () => {
      try {
        const response = await CPManageService.getPermissionCount()
        setNewPermissionCount(response.data?.pendingRequests);
        console.log(response.data?.pendingRequests);
      } catch (err) {
        console.error(err);
      }
    }
    getPermissionCount();
  },[])
  useEffect(() => {
    const getDashboardCount = async () => {
      try {
        const response = await CPManageService.CPManagementDashboardCount()
        console.log("DashboardCount", response.data);
        setDashboardCount(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    getDashboardCount();
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  const handleNewRequest = () => {
    const path = userRole === "Admin" ? "/admin" : "/cmo";
    navigate(`${path}/cp-new-permission-list`);
  };

  const handleUnassignSection = (section) => {
    const path = userRole === "Admin" ? "/admin" : "/cmo";
  
    if (!dashboardCount) {
      alert("Dashboard data not available.");
      return;
    }

    
  
    const isUnassignLead = section === "unassign-lead";
    console.log("isUnassignLead" , isUnassignLead)
    const count = isUnassignLead 
      ? dashboardCount?.unAssignedLeadsCount 
      : dashboardCount?.unAssignedLeadWithFollowUpsCount;
  
    if (count === 0) {
      showInfoToast("No unassigned leads found");
      return;
    }
  
    navigate(`${path}/cp-unassignleads-list`, {
      state: {
        section,
        count,
        type: !isUnassignLead,
      },
    });
  };
  

  return (
    <div className="bg-appGrayBackground  pb-16 ">
      <AdminAppBar />
      <ToastContainer/>
      <div className="mt-20 pt-8 px-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-6">
            <BackArrows onClick={handleBack} />
            <h1 className="text-[32px] font-semibold">CP Management</h1>
          </div>

          <div
            onClick={handleNewRequest}
            className="bg-white  cursor-pointer text-[24px] text-customGreen font-medium border border-customGreen px-2 py-2 text-center rounded-lg"
          >
            New Request : <span className="text-red-600">{newPermissionCount}</span>
          </div>
        </div>

        <div className="mt-[40px] flex items-center gap-9">
          <div className="w-[176px] p-4 text-center bg-[#AFE2FC] flex flex-col justify-center items-center h-[148px] rounded-3xl">
            <div className="text-[32px] font-semibold">{dashboardCount?.totalLeadsCount || 0}</div>
            <div className="text-[20px] font-medium">Total Received Leads</div>
          </div>

          <div
            onClick={() => handleUnassignSection("unassign-lead")}
            className="w-[176px] cursor-pointer p-4 text-center bg-[#EBEBFF] flex flex-col justify-center items-center h-[148px] rounded-3xl"
          >
            <div className="text-[32px] font-semibold">{dashboardCount?.unAssignedLeadsCount || 0}</div>
            <div className="text-[20px] font-medium">Unassigned Leads</div>
          </div>

          <div
            onClick={() => handleUnassignSection("unassign-lead-followup")}
            className="w-[176px] cursor-pointer p-4 text-center bg-[#FFEAAE] flex flex-col justify-center items-center h-[148px] rounded-3xl"
          >
            <div className="text-[32px] font-semibold">{dashboardCount?.unAssignedLeadWithFollowUpsCount || 0}</div>
            <div className="text-[20px] font-medium">
              Unassigned Leads with Followup
            </div>
          </div>
        </div>

        <div className="flex items-center  gap-12">
          <MemberList totalMember={members?.length} mockMembers={members} />

          <LeadList title={"Assigned Leads"} totalLeads={totalLead} mockLeads={leads} handleSearchLead={handleSearchLead} fetchLeads={getLeadList}/>
        </div>
      </div>
    </div>
  );
};

export default ChannelPartnerPageWithMembers;
